export const GET_SUBJECTS = 'subjects/getSubjects';
export const CREATE_SUBJECT = 'subjects/createSubject';
export const CREATE_SUBJECTS = 'subjects/createSubjects';
export const UPDATE_SUBJECT = 'subjects/updateSubject';
export const DELETE_SUBJECT = 'subjects/deleteSubject';
